import { WhiteBox, FormUnit } from "@foodpilot/foods";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { ScoreValue } from "src/api/client-api/post/scoreSchema";
import { ScoreImprovement } from "src/types";

export type BlockItemContainerProps = {
    title: string;
    value: number | null;
    comparisonValues?: {
        currentValue: ScoreValue;
        comparedTo: ScoreValue;
        improvement: ScoreImprovement;
    };
    unit?: string;
    fields?: JSX.Element[];
};
export const BlockItemContainer = (props: BlockItemContainerProps) => {
    const { title, value, unit, fields } = props;

    const theme = useTheme();

    const fieldsToDisplay = Array.isArray(fields) ? fields : [fields];
    const isContent = fields !== undefined;

    const maxIndexForSeparator = fieldsToDisplay.length - 1;

    const currentValue = props.comparisonValues?.currentValue ?? null;
    const comparedTo = props.comparisonValues?.comparedTo ?? null;
    return (
        <WhiteBox>
            <Box
                sx={{
                    borderBottom: isContent ? `1px solid ${theme.custom.grey[500]}` : "none",
                }}
            >
                <Stack
                    flexDirection={"row"}
                    gap={theme.spacing(2)}
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: theme.spacing(2, 4, 2, 4),
                    }}
                >
                    <Typography variant="h4">{title}</Typography>
                    {value !== null && (
                        <Box sx={{ display: "flex", gap: theme.spacing(2) }}>
                            <FormUnit
                                value={value}
                                unit={unit ?? ""}
                                comparison={
                                    props.comparisonValues !== undefined ?
                                        {
                                            value: currentValue,
                                            toCompareTo: comparedTo,
                                            improvement: props.comparisonValues.improvement,
                                        }
                                    :   undefined
                                }
                            />
                        </Box>
                    )}
                </Stack>
            </Box>

            {isContent && (
                <Stack
                    sx={{
                        padding: theme.spacing(3, 0, 3, 0),
                    }}
                >
                    {fieldsToDisplay.map((field, index) => {
                        return (
                            <Fragment key={`blockItemContainer-${index}`}>
                                {field}
                                {maxIndexForSeparator !== index && (
                                    <Box
                                        sx={{
                                            marginBlock: theme.spacing(2),
                                            borderBottom: `1px solid ${theme.custom.grey[500]}`,
                                        }}
                                    />
                                )}
                            </Fragment>
                        );
                    })}
                </Stack>
            )}
        </WhiteBox>
    );
};
